import React, { useState } from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface UsernameFormProps {
  initialUsername: string;
  userId: string;
  onUsernameUpdate: (username: string) => void;
}

const UsernameForm: React.FC<UsernameFormProps> = ({ initialUsername, userId, onUsernameUpdate }) => {
  const [username, setUsername] = useState(initialUsername);
  const { toast } = useToast();

  async function updateProfile(event: React.FormEvent) {
    event.preventDefault();
    try {
      const updates = {
        id: userId,
        username,
        updated_at: new Date().toISOString(),
      };

      const { error } = await supabase
        .from('profiles')
        .upsert(updates);

      if (error) throw error;

      onUsernameUpdate(username);
      toast({
        title: "Profile updated",
        description: "Your profile has been updated successfully.",
      });
    } catch (error) {
      console.error('Error updating profile:', error);
      toast({
        title: "Error updating profile",
        description: "Please try again later.",
        variant: "destructive",
      });
    }
  }

  return (
    <form onSubmit={updateProfile} className="space-y-4">
      <div>
        <label htmlFor="username" className="block text-sm font-medium text-gray-700">
          Username
        </label>
        <Input
          id="username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="max-w-xs"
        />
      </div>
      <Button type="submit">Update Profile</Button>
    </form>
  );
};

export default UsernameForm;